import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';

@Component({
    selector: 'app-historial-incidencias',
    templateUrl: './historial-incidencias.component.html',
    styleUrls: ['./historial-incidencias.component.css'],
    imports: [MatIconButton, MatIcon, MatFormField, MatLabel, MatInput]
})
export class HistorialIncidenciasComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<HistorialIncidenciasComponent>,) { }

  ngOnInit() {
  }
  onCloseClick() {
    this.dialogRef.close();
  }

}
